import { Redirect } from 'react-router-dom';

/** Legacy URLs (`/data_quality_statistics`, `/delta_forge`) → `/delta-forge`. */
const DeltaForgeLegacyPathRedirect = () => {
  return <Redirect to='/delta-forge' />;
};

export default DeltaForgeLegacyPathRedirect;
